import MenuItem from "@mui/material/MenuItem";
import { IconButton } from "@mui/material";
import { ReactNode, useEffect, useState } from "react";
import { PenIcon, TrashIcon } from "../../images";
import { AddClientModal, RemoveClientModal } from "../modal";
import { MoreVertIcon } from "../../images/MoreVertIcon";
import { StyledMenu } from "../StyledMenu";
import { Client } from "../../../types/apiTypes";
import { useAppSelector } from "../../../hooks";
import { selectPermissions } from "../../../features/permissionsSlice";

enum MenuModals {
  discard = "discard",
  edit = "edit",
  none = "none",
}

type Props = {
  client: Client;
  isNoClient: boolean;
};

export const ClientMenu = ({ client, isNoClient }: Props) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [openModal, setOpenModal] = useState<MenuModals>(MenuModals.none);
  const [currentFlow, setCurrentFlow] = useState<string>("");

  const { isAllowedShareAccess } = useAppSelector(selectPermissions);

  useEffect(() => {
    if (currentFlow) {
      setCurrentFlow("");
    }
  }, [currentFlow]);

  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const onSuccessDiscardHandler = () => {
    setOpenModal(MenuModals.none);
    setAnchorEl(null);
  };

  const onCloseHandler = () => {
    setOpenModal(MenuModals.none);
    setAnchorEl(null);
  };

  const options = [
    {
      label: "Edit Details",
      textColor: "#585858",
      icon: <PenIcon color={"#585858"} />,
      onClick: () => setOpenModal(MenuModals.edit),
    },
    {
      label: "Delete Client User",
      textColor: "#C0392B",
      icon: <TrashIcon color={"#CF3E00"} />,
      onClick: () => setOpenModal(MenuModals.discard),
    },
  ];

  const modal: Record<MenuModals, ReactNode> = {
    [MenuModals.discard]: (
      <RemoveClientModal
        id={client.id}
        onClose={onCloseHandler}
        onSuccessHandler={onSuccessDiscardHandler}
      />
    ),
    [MenuModals.edit]: (
      <AddClientModal client={client} onClose={onCloseHandler} />
    ),
    [MenuModals.none]: null,
  };

  return (
    <div>
      <IconButton
        aria-label="more"
        id="long-button"
        aria-controls={open ? "long-menu" : undefined}
        aria-expanded={open ? "true" : undefined}
        aria-haspopup="true"
        onClick={handleClick}
        disabled={isNoClient || !isAllowedShareAccess}
      >
        <MoreVertIcon width="24" />
      </IconButton>
      <StyledMenu
        id="demo-customized-menu"
        MenuListProps={{
          "aria-labelledby": "demo-customized-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        sx={{
          "& .MuiPaper-root": {
            backgroundColor: "white",
          },
        }}
      >
        {options.map(({ label, onClick, icon, textColor }) => (
          <MenuItem
            key={label}
            sx={{
              display: "flex",
              gap: "12px",
              alignItems: "center",
              color: textColor,
            }}
            onClick={onClick}
          >
            {icon}
            {label}
          </MenuItem>
        ))}
      </StyledMenu>

      {modal[openModal]}
    </div>
  );
};
